import { Box, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";

const StatusChip = ({ circleColor, label, insetBoxShadow = false }) => {
  const colors = useColors();
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      alignContent={"baseline"}
      justifyContent={"center"}
      height={"24px"}
      gap={1}
      padding={"2px 10px"}
      sx={{
        border: "1px solid " + colors.button_outlined_inherit_enabled_stroke,
        borderRadius: "12px",
      }}
    >
      <Box
        sx={{
          backgroundColor: circleColor,
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          boxShadow: insetBoxShadow
            ? "0px 0px 1px 0.5px " + colors.grey_24percent + " inset"
            : "none",
        }}
      />
      <Typography variant="caption" color={colors.text_secondary} noWrap>
        {label}
      </Typography>
    </Box>
  );
};

export default StatusChip;
